'use strict';

module.exports = function pull(key) {
  var value = this.items[key] || null;
  delete this.items[key];
  return value;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/pull.js
// module id = 279
// module chunks = 0